import axiosInstance from '@api/axios.ts';
import { urls } from '@api/urls.ts';
import { CustomGPTFormFields } from '@features/admin-multi-document-agent/utils/custom-gpt/custom-gpt-validator';
import {
  Agent,
  AgentChatSession,
  ConversationStarter,
  Tool,
} from '@app/types/agents';

export const saveAgent = async (
  data: Partial<CustomGPTFormFields>
): Promise<Agent> => {
  const response = await axiosInstance.post(urls.agents.base, data);
  return response.data;
};

export const updateAgent = async (
  agentId: number,
  data: Partial<CustomGPTFormFields>
): Promise<Agent> => {
  const response = await axiosInstance.patch(urls.agents.byId(agentId), data);
  return response.data;
};

export const deleteAgent = async (agentId: number): Promise<void> => {
  const response = await axiosInstance.delete(urls.agents.byId(agentId));

  return response.data;
};

export const getAgent = async (agentId: number): Promise<Agent> => {
  const response = await axiosInstance.get(urls.agents.byId(agentId));
  return response.data;
};

export const uploadAgentAvatar = async (
  agentId: number,
  file: File
): Promise<Agent> => {
  const formData = new FormData();
  formData.append('avatar', file);

  const response = await axiosInstance.patch(
    urls.agents.byId(agentId),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const createPreviewSession = async (
  agentId: number
): Promise<AgentChatSession> => {
  const response = await axiosInstance.post(urls.agents.createPreview(agentId));
  return response.data;
};

export const createLiveSession = async (
  agentId: number
): Promise<AgentChatSession> => {
  const response = await axiosInstance.post(urls.agents.createLive(agentId));
  return response.data;
};

export const publishAgent = async (agentId: number): Promise<any> => {
  const response = await axiosInstance.post(urls.agents.publish(agentId));
  return response.data;
};

// Tools and starters
export const getTools = async (): Promise<Tool[]> => {
  const response = await axiosInstance.get(urls.tools.base);
  return response.data;
};

export const getConversationStarters = async (): Promise<
  ConversationStarter[]
> => {
  const response = await axiosInstance.get(urls.conversationStarters.base);
  return response.data;
};
